import {Expense} from "models/Expense";
import {Invoice} from "models/Invoice";
import {AccountableContainer, FilterFinalInvoices} from "models/InvoiceContainer";
import React from "react";
import {connect} from "react-redux";
import {RootState} from "store/store";
import {InvoiceState} from 'store/reducers/Invoices';
import {ExpenseState} from 'store/reducers/Expenses';
import {Card, CardBody} from "reactstrap";
import CardHeader from "components/CardHeader";
import {useOfficeTranslation} from "i18n/OfficeTranslation";

interface Props {
    invoiceState: InvoiceState;
    tenantId: string;
    expenseState: ExpenseState;
}

const LastQCard: React.FC<Props> = ({invoiceState, expenseState, tenantId}) => {
    const {intlLocale, t} = useOfficeTranslation();

    const amountPrevQInvoices = (new AccountableContainer<Invoice>(invoiceState.getInvoices().filter(invoice => invoice.tenant === tenantId)))
        .RangePreviousQuarter()
        .Filter(FilterFinalInvoices)
        .CalcTotal(invoice => invoice.CalcTotalContents())

    const amountPrevQExpenses = (new AccountableContainer<Expense>(expenseState.getExpenses().filter(expense => expense.tenant === tenantId)))
        .RangePreviousQuarter()
        .CalcTotal(expense => expense.tax)

    return (
        <Card className="h-100 mb-0">
            <CardBody>
                <CardHeader title={t("common.lastQCard.lastQuarter")} icon="mdi-calendar-range-outline" />
                <div className="border-bottom py-3">
                    <h4 className="mb-0">{new Intl.NumberFormat(intlLocale, {style: "currency", currency: "EUR"}).format(amountPrevQInvoices)} {t("common.lastQCard.ex")}</h4>
                </div>
                <p className="text-muted pt-3 mb-0">
                    <span className="badge badge-soft-danger me-1">
                        {new Intl.NumberFormat(intlLocale, {style: "currency", currency: "EUR"}).format(amountPrevQExpenses)}
                    </span>
                    {t("common.lastQCard.expenseTaxes")}
                </p>
            </CardBody>
        </Card>
    );

}

const mapStateToProps = (state: RootState) => {
    return {
        invoiceState: state.Invoices,
        expenseState: state.Expenses
    };
};

export default connect(mapStateToProps)(LastQCard);
